import { AttendanceClient } from '@@api';
import {
  ICommand,
  ICommandHandlerMethod,
  ICommandHandlerRegistryService,
  ServiceNames,
} from '@4r/mf-contracts-4services';
import { getService } from '@4r/mf-app';
import {
  ClockCommand,
  COMMAND_CLOCK_IN,
  COMMAND_CLOCK_OUT,
} from './ClockCommand';

export function registerCommandHandlers(attendanceClient: AttendanceClient) {
  const handlers: Record<string, ICommandHandlerMethod<any>> = {
    [COMMAND_CLOCK_IN]: (cmd: ClockCommand) => attendanceClient.clockIn(cmd),
    [COMMAND_CLOCK_OUT]: (cmd: ClockCommand) => attendanceClient.clockOut(cmd),
  };

  const registry = getService<ICommandHandlerRegistryService>(
    ServiceNames.CommandRegistry,
  );

  registry.registerCommandHandlers(
    'TimeAttendanceMicrofrontend',
    handlers as Record<string, ICommandHandlerMethod<ICommand>>,
  );
}
